'use strict';

import {Dictionary} from '../common';

const ARG_REGEXP = /{.*?}/g;

class UrlService {
    buildUrl(urlTpl: string, ...ids: any[]) {
        const args = Array.isArray(ids) ? [...ids] : [ids];
        return urlTpl.replace(ARG_REGEXP, () => args.shift());
    }

    extractIdsFromUrl(urlTpl: string, url: string): string[] {
        const urlTplParts = urlTpl.split('/').slice(1);
        const urlParts = url.split('/').slice(1);

        const idIdxs: number[] = urlTplParts.reduce((acc: number[], el: string, i: number) => {
            return el.match(ARG_REGEXP) ? [...acc, i] : acc;
        }, []);

        return urlParts.filter((el: string, idx: number) => {
            return idIdxs.includes(idx);
        });
    }

    mapIdsFromUrl(urlTpl: string, url: string): Dictionary<string> {
        const urlTplParts = urlTpl.split('/').slice(1);
        const urlParts = url.split('/').slice(1);

        return urlTplParts.reduce(
            (result: Dictionary<string>, el: string, index: number) =>
                el.match(ARG_REGEXP) && urlParts[index] ? {...result, [el.slice(1, -1)]: urlParts[index]} : result,
            {},
        );
    }
}

export const urlService = new UrlService();
